var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.totalPages > 1
    ? _c(
        "nav",
        {
          staticClass: "wkb-graph-table-pagination",
          attrs: { "aria-label": _vm.ariaLabel },
        },
        [
          _c(
            "div",
            { staticClass: "wkb-graph-table-pagination-pill" },
            [
              _c(
                "button",
                {
                  staticClass: "wkb-graph-table-pagination-btn",
                  attrs: {
                    type: "button",
                    "aria-label": "First page",
                    disabled: _vm.currentPage <= 1,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.goToPage(1)
                    },
                  },
                },
                [_vm._v(" « ")]
              ),
              _c(
                "button",
                {
                  staticClass: "wkb-graph-table-pagination-btn",
                  attrs: {
                    type: "button",
                    "aria-label": "Previous page",
                    disabled: _vm.currentPage <= 1,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.goToPage(_vm.currentPage - 1)
                    },
                  },
                },
                [_vm._v(" ‹ ")]
              ),
              _vm._l(_vm.pageItems, function (item, index) {
                return [
                  item === "ellipsis"
                    ? _c(
                        "span",
                        {
                          key: `ellipsis-${index}`,
                          staticClass: "wkb-graph-table-pagination-ellipsis",
                          attrs: { "aria-hidden": "true" },
                        },
                        [_vm._v(" … ")]
                      )
                    : _c(
                        "button",
                        {
                          key: `page-${item}`,
                          staticClass: "wkb-graph-table-pagination-btn",
                          class: { "is-active": item === _vm.currentPage },
                          attrs: {
                            type: "button",
                            "aria-label": `Page ${item}`,
                            "aria-current":
                              item === _vm.currentPage ? "page" : undefined,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.goToPage(item)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(item) + " ")]
                      ),
                ]
              }),
              _c(
                "button",
                {
                  staticClass: "wkb-graph-table-pagination-btn",
                  attrs: {
                    type: "button",
                    "aria-label": "Next page",
                    disabled: _vm.currentPage >= _vm.totalPages,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.goToPage(_vm.currentPage + 1)
                    },
                  },
                },
                [_vm._v(" › ")]
              ),
              _c(
                "button",
                {
                  staticClass: "wkb-graph-table-pagination-btn",
                  attrs: {
                    type: "button",
                    "aria-label": "Last page",
                    disabled: _vm.currentPage >= _vm.totalPages,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.goToPage(_vm.totalPages)
                    },
                  },
                },
                [_vm._v(" » ")]
              ),
            ],
            2
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }